import React, { useState } from 'react';
import { ReactComponent as MenuItem } from '../../assets/menu_icon.svg';
import { ReactComponent as MenuItemActive } from '../../assets/menu_icon_active.svg';
import './Navigation.css';

function Navigation() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleBurgerClick = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className={`w-1/12 overflow-x-hidden min-w-28 pl-16 bg-white flex flex-col z-50 ${isMenuOpen ? 'full' : ''}`}>
            <div className="burger flex items-center ">
                <div
                    className={`cursor-pointer burger-menu flex flex-col ${isMenuOpen ? 'open' : ''}`}
                    onClick={handleBurgerClick}
                >
                    <div className="burger-item"></div>
                    <div className="burger-item"></div>
                    <div className="burger-item"></div>
                </div>
            </div>
            <div className="holders flex flex-col justify-between">
                <MenuItem/><MenuItemActive/><MenuItem/><MenuItem/>
            </div>
            <div className="submenu flex flex-col h-full bg-green-200">
                <div className="user-info">
                    <h2 className="user-name category-title-font">Rodion Krainov</h2>
                    <h2 className="user-email">r.krainov@innopolis.university</h2>
                </div>
                <ul className="menu-items">
                    <li className="element-font">Personal Information</li>
                    <li className="element-font current">Sport</li>
                    <li className="element-font">Events</li>
                    <li className="element-font">Psychologist</li>
                </ul>
            </div>

        </nav>
    );
}

export default Navigation;
